/* eslint-disable no-nested-ternary */
import { createSelector } from 'reselect';

import { I18n } from 'react-redux-i18n';
import languagesMap from '../../constants/languages';
import { sorLanguageListToPlaceInterfaceLanguageTop, sortLanguageListAlphabetically } from '../../lib/language';

const getLanguages = (state) => state.user.assessmentsLanguages;
const getTests = (state) => state.user.tests;
const getBatteries = (state) => state.user.batteries;
const getUserCredits = (state) => state.user.user?.credits;
const getUserFrozenCredits = (state) => state.user.user?.totalFrozenCredits;
const getBiodataTemplates = (state) => state.user.biotemplates;

// eslint-disable-next-line import/prefer-default-export
export const selectAvailableLanguages = createSelector([getLanguages], (languages) => {
  return languages
    ? sorLanguageListToPlaceInterfaceLanguageTop(
        sortLanguageListAlphabetically(
          languages.map((item) => ({
            code: item.langID,
            value: item.langID,
            label: languagesMap[item.langID] || item.langID,
          })),
        ),
      )
    : [];
});

export const selectAssessments = createSelector([getTests, getBatteries], (tests, batteries) => [
  ...tests.filter((test) => !test.isBatteryOnly),
  ...batteries,
]);

export const selectUserCredits = createSelector(
  [getUserCredits, getUserFrozenCredits],
  (credits = 0, frozenCredits = 0) => credits - frozenCredits,
);

// helper func
export const calculateCredits = (credits = 0, frozenCredits = 0) => credits - frozenCredits;

const defaultCompleteBioTemplate = { label: I18n.t('defaultCompleteBioTemplate'), value: 0, isDefault: true };
const defaultEmptyBioTemplate = { label: I18n.t('defaultEmptyBioTemplate'), value: -1, isDefault: false };

export const selectAvailableMappedBiodataTemplates = createSelector([getBiodataTemplates], (templates) => {
  const biotemplates = templates.map((templateItem) => ({
    label: templateItem.name,
    value: templateItem.id,
    isDefault: templateItem.isDefault,
  }));
  biotemplates.unshift(defaultEmptyBioTemplate);
  biotemplates.unshift(defaultCompleteBioTemplate);
  return biotemplates;
});
